import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
/**
 * Denúncia de uma mensagem do chat. Não usa o flarum/flags porque lá
 * `flags.post_id` é uma FK obrigatória para `posts`.
 */
export default class MessageFlag extends Model {
  constructor() {
    super(...arguments);
    /** Uma das chaves de MessageFlag::REASONS no servidor. */
    _defineProperty(this, "reason", Model.attribute('reason'));
    /** Texto do denunciante; sempre exibido como texto, nunca como HTML. */
    _defineProperty(this, "detail", Model.attribute('detail'));
    _defineProperty(this, "messageId", Model.attribute('messageId'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "resolvedAt", Model.attribute('resolvedAt', Model.transformDate));
    _defineProperty(this, "isResolved", Model.attribute('isResolved'));
    /** Null se o denunciante apagou a conta; a denúncia continua. */
    _defineProperty(this, "user", Model.hasOne('user'));
    _defineProperty(this, "message", Model.hasOne('message'));
    _defineProperty(this, "resolvedBy", Model.hasOne('resolvedBy'));
  }
  apiEndpoint() {
    return '/chat-message-flags' + (this.exists ? '/' + this.id() : '');
  }
}
flarum.reg.add('ramon-chat', 'common/models/MessageFlag', MessageFlag);